import { useUserStrategies } from '../../../context/UserStrategies';
import { IStrategy } from '../../../types/model';
import { truncateString } from '../../../helpers/functions';
import { DropdownMenu } from '../../form';
import { StrategyLabel } from '../../Strategies/StrategyLabel';

export const Tabs = ({
  selectedStrategy,
  selectedStrategies,
  onTabChange,
  restoreTab,
  multiple = true,
}: {
  collapsed?: boolean;
  selectedStrategy: IStrategy;
  selectedStrategies: string[];
  onTabChange(id: string, index?: number): void;
  restoreTab(index: number): void;
  multiple?: boolean;
}) => {
  const { strategies } = useUserStrategies();

  const handleClick = (id: string, index?: number) => {
    id.length > 0 && onTabChange(id, index);
  };

  const dropdownItems = strategies.reduce(
    (arr, { id, color, name }) =>
      selectedStrategies.includes(id)
        ? arr
        : [
            ...arr,
            <StrategyLabel
              color={color}
              className="border-none ml-3"
              key={id}
              name={name}
            />,
          ],
    [] as JSX.Element[]
  );

  const dropdownItemsData = strategies.reduce(
    (arr, { id }) => (selectedStrategies.includes(id) ? arr : [...arr, id]),
    [] as string[]
  );

  return (
    <div className="flex h-18 min-h-18 w-full overflow-x-auto scrollbar-hide gap-4">
      {selectedStrategies.map((selectedId, index) => {
        const str = strategies.find(({ id }) => id === selectedId);
        return (
          <StrategyTab
            key={(str ? str.id : 'tab_') + index}
            id={str ? str.id : ''}
            isSelected={str?.id === selectedStrategy.id}
            index={index}
            color={str ? str.color : 'transparent'}
            dropdownItems={dropdownItems}
            dropdownItemsData={dropdownItemsData}
            name={str ? str.name : 'Choose strategy'}
            handleClick={handleClick}
            restoreTab={restoreTab}
            multiple={multiple}
          />
        );
      })}
    </div>
  );
};

const StrategyTab = ({
  id,
  isSelected,
  index,
  color,
  name,
  dropdownItems,
  dropdownItemsData,
  handleClick,
  restoreTab,
  multiple = true,
}: {
  id: string;
  isSelected: boolean;
  index: number;
  color: string;
  name: string;
  dropdownItems: JSX.Element[];
  dropdownItemsData: string[];
  handleClick(id: string, index?: number): void;
  restoreTab(index: number): void;
  multiple?: boolean;
}) => (
  <div
    className={`
        flex
        items-center
        justify-start
        px-4
        h-full
        w-full
        flex-1
        sm:overflow-x-scroll
        scrollbar-hide
      `}
  >
    <StrategyLabel
      color={color}
      onClose={id.length > 0 ? () => restoreTab(index) : undefined}
      onClick={() => handleClick(id)}
      viewType={id.length > 0 && multiple ? 'tag' : 'label'}
      className={` -mr-5 pr-5`}
      name={name.length <= 20 ? name : truncateString(name, 20)}
    />
    <DropdownMenu
      dropdownTooltipClassName={`
        bg-white
        border-solid
        border
        border-grey-10
        mt-3
      `}
      dropdownItems={dropdownItems}
      dropdownItemsData={dropdownItemsData}
      showArrow={dropdownItems.length === 0 ? false : true}
      arrowPosition="right"
      handleClick={(_, id) => handleClick(id, index)}
      hideOnItemClick
    />
  </div>
);
